export const vendorMixins = {
  computed: {
    /**
     * Returns whether or not user has permission to add a vendor
     */
    userCanCreateVendor () {
      return this.$store.getters.checkIfUserHasRequiredPermissions(['system.add_vendor'])
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/VendorMixins.js